import React from "react";
import { Tooltip } from "react-tooltip";
import PropTypes from "prop-types";
import DoubleDial from "../../../components/doubleDials/doubleDials";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import MoneyDisplay from "../../../components/moneyDisplay/moneyDisplay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { formatCurrencySymbol } from "../../../utils/formatters";

const DonutForecastModule = (props) => {
  return (
    <SectionContainer title={props.title}>
      <Tooltip id="forecast-tooltip" float />
      <div
        className="left"
        style={{ ...styles.left, width: props.width !== undefined ? "25%" : "50%" }}
      >
        {props.isStaffView ? (
          <p style={styles.metric.staff}>{props.entityName}</p>
        ) : (
          <p style={styles.metric.location}>
            {!props.singleLocation ? props.metricLocation : null}
          </p>
        )}

        <p className="metric-title" style={styles.metric.title}>
          {props.metricTitle}
        </p>
        <DoubleDial
          hideForecast={props.hideForecast}
          currentData={[
            { name: "Current", value: props.value },
            { name: "Remain", value: 100 - props.value }
          ]}
          pacingData={[
            { name: "Pacing", value: props.forecastValue },
            { name: "Remain", value: 100 - props.forecastValue }
          ]}
        />
      </div>
      <div
        className="right"
        style={{ ...styles.right, width: props.width !== undefined ? "25%" : "50%" }}
      >
        <p className="total" style={styles.total}>
          Total
        </p>
        <MoneyDisplay
          value={props.goalCurrentVal}
          size={24}
          currency={formatCurrencySymbol(
            props.metricTitle,
            props.currencySymbol !== undefined && props.currencySymbol
          )}
        />
        {props.hideForecast ? null : (
          <>
            <p className="total" style={styles.total}>
              Forecast{" "}
              <a
                href="https://ikizmet.zendesk.com/hc/en-us/articles/19321074657677-Goal-Forecasting"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  data-tooltip-content="Click here to learn how this forecast is calculated."
                  data-tooltip-id="forecast-tooltip"
                  icon={faQuestionCircle}
                  style={{ color: "var(--color-icons-bg)" }}
                />
              </a>
            </p>
            <MoneyDisplay
              value={props.currentValPacing}
              size={24}
              currency={formatCurrencySymbol(props.metricTitle, props.currencySymbol)}
              color="#fd6a3e"
            />
          </>
        )}
        <p className="total" style={styles.total}>
          Goal
        </p>
        <MoneyDisplay
          value={
            props.goalUsesPercent ? props.goalCurrentVal + props.goalRemainValue : props.goalValue
          }
          size={24}
          currency={formatCurrencySymbol(props.metricTitle, props.currencySymbol)}
          color="#a9c0e2"
        />
      </div>
    </SectionContainer>
  );
};

var styles = {
  sectionContainer: {
    width: "600px"
  },
  left: {
    width: "50%",
    float: "left"
  },
  right: {
    width: "50%",
    float: "left",
    paddingTop: "35px"
  },
  forecast: {
    color: "#fd6a3e",
    fontSize: "20px",
    paddingTop: "5px",
    percent: {
      fontSize: "12px"
    }
  },
  forecastIcon: {
    width: "5px",
    height: "16px",
    backgroundColor: "#fd6a3e",
    display: "block",
    float: "left",
    marginTop: "6px",
    marginRight: "7px"
  },
  metric: {
    title: {
      color: "#8791a0",
      fontsize: "16px",
      textTransform: "uppercase",
      fontWeight: "700",
      lineHeight: "12px",
      whiteSpace: "nowrap",
      position: "relative",
      top: "-6px",
      marginBottom: "25px",
      fontSize: "12px"
    },
    location: {
      color: "#87919f",
      fontSize: "12px",
      lineHeight: "15px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    staff: {
      color: "#87919f",
      fontSize: "12px",
      lineHeight: "15px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  },
  total: {
    color: "#787c87",
    lineHeight: "10px",
    paddingTop: "15px"
  }
};

export default DonutForecastModule;

DonutForecastModule.propTypes = {
  forecastValue: PropTypes.number,
  value: PropTypes.number,
  title: PropTypes.string,
  metricTitle: PropTypes.string,
  metricLocation: PropTypes.string,
  goalCurrentVal: PropTypes.number,
  goalRemainValue: PropTypes.number,
  currencySymbol: PropTypes.string,
  currentValPacing: PropTypes.number,
  currentUser: PropTypes.object,
  width: PropTypes.string,
  goalUsesPercent: PropTypes.bool,
  goalValue: PropTypes.number
};
